import { Component, OnInit, Input, OnChanges, SimpleChanges } from "@angular/core";
import { SearchService } from "../../../services/search.service";
import { Cost } from "../../../models/cost.model";
import { debounceTime, switchMap, startWith } from "rxjs/operators";
import { Observable, of, BehaviorSubject, combineLatest } from "rxjs";
import { FormControl } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { Router } from "@angular/router";

@Component({
  selector: "app-search-results",
  templateUrl: "./search-results.component.html",
})
export class SearchResultsComponent implements OnInit, OnChanges {
  state$: Observable<{ loading: boolean; data: Cost[]; empty: boolean; error: string | null }>;
  searchCtrl = new FormControl();
  private filterByEmployeeId$ = new BehaviorSubject<number | null>(null);

  @Input() value = "";
  @Input() minLength = 3;
  @Input() placeholder = "Szukaj dokumentów...";
  @Input() filterByEmployeeId: number | null = null;

  constructor(private searchService: SearchService, private router: Router) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.filterByEmployeeId) {
      this.filterByEmployeeId$.next(this.filterByEmployeeId);
    }
  }

  ngOnInit() {
    this.filterByEmployeeId$.next(this.filterByEmployeeId);
    
    this.state$ = combineLatest([
      this.searchCtrl.valueChanges.pipe(startWith('')),
      this.filterByEmployeeId$
    ]).pipe(
      debounceTime(500),
      switchMap(([searchValue, employeeId]) => {
        // Numery faktur wklejane z listy potrafią mieć spacje na końcu (np. "0030\07\2026    ")
        const phrase = typeof searchValue === "string" ? searchValue.trim() : "";
        if (phrase.length >= this.minLength) {
          return this.searchService.searchState(phrase, employeeId);
        }
        return of({ loading: false, data: [], empty: false, error: null });
      })
    );
  }

  onSelectedOption(selectedOption: MatAutocompleteSelectedEvent) {
    const cost = selectedOption.option.value;

    if (cost.isKsef) {
      let targetParams: any = {};
      if (cost.realId) {
        targetParams.highlightKsefId = cost.realId;
      }
      
      const statusObj = cost.status || {};
      const statusName = (statusObj.name || (typeof cost.status === 'string' ? cost.status : '')).toUpperCase();

      switch (statusName) {
        case 'ASSIGNED':
          targetParams.filter = 'assigned';
          this.router.navigate(['/ksef'], { queryParams: targetParams });
          break;
        case 'DESCRIBED':
        case 'IN_CIRCULATION':
          this.router.navigate(['/ksef/in-circulation'], { queryParams: targetParams });
          break;
        case 'HRNEST_SETTLED':
          this.router.navigate(['/ksef/hrnest-settled'], { queryParams: targetParams });
          break;
        case 'CANCELLED':
        case 'RETURNED':
          this.router.navigate(['/ksef/cancelled'], { queryParams: targetParams });
          break;
        case 'PENDING_ASSIGNMENT':
        default:
          this.router.navigate(['/ksef'], { queryParams: targetParams });
          break;
      }
      return;
    }

    const costId = parseInt(cost.id, 10);
    if (!costId) {
      return;
    }

    if ("delegation" === cost.type.name) {
      this.router.navigate([`/delegation/${costId}`]);
      return;
    }



    this.router.navigate([`/cost/${costId}`]);
  }

  displayFn(cost: Cost): string {
    return cost && cost.name ? cost.name : "";
  }
}
